/*
Author : Raphaël Dardeau


Markup : 

<canvas width="860" height="500" data-chart="data.xml" data-chart-clubid="data.xml"></canvas>


Setup : 

$(function() {
    $("[data-chart]").charting();
});
*/
;(function ($, window, document, undefined) {
    "use strict";

    var _thisName = "charting",
        defaults = {
            legendTpl : '<div class="chart__legend js-chart-legend"><span class="chart__legendValue"><span class="js-chart-value"></span><sup>%</sup></span><span class="chart__legendLabel js-chart-label"></span></div>'
        };

    function _this (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = _thisName;
        this.init();
    }

    $.extend(_this.prototype, {
        init: function () {
            this.setVars();
            if (this.clubid)
                this.setClubChart();
            else
                this.setChart();
        },
        setVars: function() {
            this.$element = $(this.element);
            this.datas = this.$element.data("chart");
            if (this.$element.data("chart-clubid"))
                this.clubid = this.$element.data("chart-clubid");
        },
        setChart: function() {
            if (this.$element.find(".js-chart-legend1").length && this.$element.find(".js-chart-legend2").length) {
                if (this.$element.find(".js-chart-value").length) {
                    this.$element.find(".js-chart-legend1 .js-chart-value").text(this.datas[0].value);
                    this.$element.find(".js-chart-legend2 .js-chart-value").text(this.datas[1].value);
                }
                if (this.$element.find(".js-chart-label").length) {
                    this.$element.find(".js-chart-legend1 .js-chart-label").text(this.datas[0].label);
                    this.$element.find(".js-chart-legend2 .js-chart-label").text(this.datas[1].label);
                }
            } else {
                for (var i in this.datas) {
                    if (this.datas[i].label) {
                        this.$element.append(this.settings.legendTpl);
                        this.$element.find(".js-chart-legend:last .js-chart-value").text(this.datas[i].value);
                        this.$element.find(".js-chart-legend:last .js-chart-label").text(this.datas[i].label);
                    } else if (this.datas[i].caption) {
                        this.$element.find(".js-chart-caption").text(this.datas[i].caption);
                    }
                } 
            }
            this.drawPieChart();
        },
        drawPieChart: function() {
            var datas = [];
            var colors = ["#7ebc38", "#e30613", "#f2f2f2", "#ffd350", "#e5711e", "#be82b8", "#d4202b", "#8b9a93", "#c88c12", "#377c2b", "#01b195", "#005188"];
            for (var i in this.datas) {
                if (this.datas[i].label) {
                    datas.push({
                        value: this.datas[i].value,
                        label: this.datas[i].label,
                        color: colors[i]
                    });
                }
            }
            var options = {
                animationEasing: "easeInQuad",
                responsive:true,
                segmentShowStroke : true,
                segmentStrokeColor : "#f2f2f2",
                segmentStrokeWidth : 2,
                percentageInnerCutout : 66,
                tooltipTemplate : '<%=label%> : <%=value %>%'
            };
            if (Modernizr.canvas)
                new Chart(this.$element.find(".js-chart-pie")[0].getContext("2d")).Doughnut(datas, options);
        },
        setClubChart: function() {
            var _this = this;
            this.dayLabel = [];
            this.rank = [];
            this.score = [];
            $.ajax({
                type: 'GET',
                url: this.datas,
                dataType: "xml",
                success: function(xml) {
                    var $dataset = $(xml).find('dataset');
                    _this.teamsCount = $dataset.length;
                    _this.daysCount = (_this.teamsCount -1 ) * 2;
                    for (var i = 0; i < _this.daysCount; i++) {
                        _this.dayLabel.push((i+1)+'e j.');
                    }
                    $dataset.each(function(i) {
                        if ($(this).attr('idClub') == _this.clubid) {
                            $(this).find('set').each(function(){
                                _this.dayLabel[parseInt($(this).attr('num_journee'))-1] += ', ' + $(this).attr('Eq1') + ' ' + $(this).attr('score') + ' ' + $(this).attr('Eq2');
                                _this.rank.push(((_this.daysCount/2)+2)-parseInt($(this).attr('rang')));
                            });
                            _this.drawLineChart();
                            return;
                        }
                    });
                }
            });
        },
        drawLineChart: function (params) {
            var ct_options = {
                scaleOverlay: false,
                scaleOverride: true,
                scaleStartValue: 1, 
                scaleStepWidth: 1, 
                scaleSteps: (this.teamsCount - 1),
                scaleFontFamily : "'MemphisMedium'",
                scaleFontSize : 14,
                scaleFontStyle: "normal", 
                scaleFontColor: '#999999', 
                responsive: false,
                showTooltips: true,
                scaleXGridLinesStep : 5,
                scaleYGridLinesStep : 1,
                rotateLabels: false,
                scaleBeginAtZero : true,
                scaleShowGridLines : false,
                scaleShowLines : false,
                scaleGridLineColor : "rgba(153,153,153,1)",
                scaleLineColor: "rgba(153,153,153,1)",
                scaleGridLineWidth : 0,
                scaleLineWidth : 0,
                bezierCurve : true,
                bezierCurveTension : 0.5,
                pointDot : true,
                pointDotRadius : 5,
                pointDotStrokeWidth : 1,
                pointHitDetectionRadius : 10,
                datasetStroke : true,
                datasetStrokeWidth : 2,
                datasetFill : true,
                animation : true,  
                scaleLabel : "<%=" + (this.teamsCount + 1) + "-value%>",
                animationSteps: 20,
                animationEasing: "linear",
                legendTemplate : "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].lineColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>",
                tooltipTemplate : '<%=label%> (<%=' + (this.teamsCount + 1) + '-value %>e)',
                tooltipFontSize: 14,
                tooltipFillColor: "rgba(255,255,255,0.95)",
                tooltipFontColor: "#222222",
                tooltipFontStyle: "normal",
                tooltipYPadding: 2,
                tooltipXPadding: 8
            };
            var data = {
                labels : this.dayLabel,
                datasets : [
                    {
                        label : "Evolution du Classement",
                        fillColor : "rgba(191,175,155,0)",
                        strokeColor : "rgba(191,175,155,1)",
                        pointColor : "rgba(191,175,155,1)",
                        pointStrokeColor : "rgba(23,28,34,1)",
                        data : this.rank
                    }
                ]
            };
            new Chart(this.$element[0].getContext("2d")).Line(data, ct_options);
        }
    });

    $.fn[ _thisName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "_this_" + _thisName)) {
                $.data(this, "_this_" + _thisName, new _this(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);